export const converCentsToDollars = (amount: number) => {
  return amount / 100;
};
